import { render, staticRenderFns } from "./FormFieldDesigner.vue?vue&type=template&id=4145c521&scoped=true&"
import script from "./FormFieldDesigner.vue?vue&type=script&lang=js&"
export * from "./FormFieldDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145c521",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4145c521')) {
      api.createRecord('4145c521', component.options)
    } else {
      api.reload('4145c521', component.options)
    }
    module.hot.accept("./FormFieldDesigner.vue?vue&type=template&id=4145c521&scoped=true&", function () {
      api.rerender('4145c521', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/formField/FormFieldDesigner.vue"
export default component.exports